(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/pages/teams/team-members/invitee.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/pages/teams/team-members/invitee.js');
'use strict';

const logger = svs.arena.logger;
const {
  MemberPopover,
  MemberPopoverItem
} = svs.arena.pages.teams.components;
const {
  showRemoveInviteError,
  showInviteeReminderError,
  showSendReminderNameSuccess,
  showSendReminderSuccess
} = svs.arena.pages.teams.dialogs;
const {
  deleteInviteeAsync,
  postRemindInviteeAsync
} = svs.arena.service.teamsService;
const {
  removeInvitee
} = svs.arena.store.teams.actions;
const Invitee = _ref => {
  let {
    invitation = {},
    isLeader,
    teamId
  } = _ref;
  const dispatch = ReactRedux.useDispatch();
  const [expireDate, setExpireDate] = React.useState('');
  React.useEffect(() => {
    const expires = new Date();
    try {
      expires.setSeconds(expires.getSeconds() + (invitation === null || invitation === void 0 ? void 0 : invitation.ttl));
      setExpireDate(dateFns.format(expires, 'd MMMM', {
        locale: dateFns.locales.sv
      }));
    } catch (err) {
      logger.warn('Error wrong format on date from backend', err);
      setExpireDate(false);
    }
  }, [invitation]);
  const removeMemberInvite = async () => {
    const {
      invitationId
    } = invitation;
    const {
      error
    } = await deleteInviteeAsync(teamId, invitationId);
    if (error) {
      showRemoveInviteError();
      return;
    }
    dispatch(removeInvitee({
      teamId,
      invitationId
    }));
  };
  const remind = async () => {
    const {
      error
    } = await postRemindInviteeAsync(invitation.invitationId);
    if (error) {
      showInviteeReminderError();
    } else if (invitation.firstName) {
      showSendReminderNameSuccess(invitation.firstName, invitation.lastName);
    } else {
      showSendReminderSuccess(invitation.email);
    }
  };
  return React.createElement("div", {
    className: "u-flex"
  }, React.createElement("div", {
    className: "u-flex-grow-1 padding-left-1 f-400"
  }, React.createElement("span", {
    className: "f-bold"
  }, invitation === null || invitation === void 0 ? void 0 : invitation.email), React.createElement("br", null), (invitation === null || invitation === void 0 ? void 0 : invitation.ttl) && expireDate && React.createElement(React.Fragment, null, "Giltig t.o.m.", ' ', expireDate)), React.createElement("div", {
    className: "padding-right-1 u-flex u-flex-align-items-center"
  }, isLeader && React.createElement(MemberPopover, null, React.createElement(MemberPopoverItem, {
    onClick: removeMemberInvite
  }, " Ta bort "), React.createElement(MemberPopoverItem, {
    onClick: remind
  }, " P\xE5minn "))));
};
svs.arena.pages.teams.components.Invitee = Invitee;

 })(window);